import { IdentifyByBookParams, IdentifyByChapterParams } from '~/api/antiPirate/antiPirateApiTypes';
import { provider } from '~/api/provider/provider.config';
import { handleRejectedRequest } from '~/api/provider/providerErrors';
import { RejectedRequest } from '~/api/provider/providerTypes';

const namespace = Symbol('namespace');

export const antiPirateApi = {
  [namespace]: '/v1/antiPiracy',

  async identifyByChapter(data: IdentifyByChapterParams) {
    try {
      const response = await provider.post<
      { message: string } | RejectedRequest<IdentifyByChapterParams>
      >(
        `${this[namespace]}/chapter/${data.chapterId}/identifyThePirate`,
        { body: data.body },
      );

      return response.data;
    } catch (error) {
      return await handleRejectedRequest<void>(error);
    }
  },

  async identifyByBook(data: IdentifyByBookParams) {
    const formData = new FormData();

    formData.append('file', data.file);
    formData.append('comment', data.comment);

    try {
      const response = await provider.post<
      { message: string } | RejectedRequest<IdentifyByBookParams>
      >(
        `${this[namespace]}/book/${data.slug}/identifyThePirate`,
        formData,
      );

      return response.data;
    } catch (error) {
      return await handleRejectedRequest<void>(error);
    }
  },
};
